<template>
  <svg viewBox="0 0 512 512" v-on="$listeners">
    <path
      d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192z"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="32"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M352 176L217.6 336L160 272"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'success',
}
</script>